import { FC, useContext } from 'react'
import { toBytes } from '../../../../../utils/bytes'
import { FilePicker } from '../../../../core/FilePicker'
import { useFilePicker } from '../hooks'
import { RegisterModalContext } from '../RegisterSongModal'

export const WavFilePicker: FC = () => {
  const { setWavFile, setWavFileErrors } = useContext(RegisterModalContext)
  const { getRootProps, getInputProps } = useFilePicker({
    maxFileSizeBytes: toBytes(100, 'MB'),
    acceptedFileTypes: ['audio/wav'],
    onDropAccepted: (file) => setWavFile(file),
    onDropRejected: (fileErrors) => setWavFileErrors(fileErrors)
  })

  return <FilePicker getRootProps={getRootProps} getInputProps={getInputProps} />
}
